export const getRange = (from = 0, to = 0) => {
  const range = [];

  for (let i = parseInt(from, 10); i <= parseInt(to, 10); i += 1) {
    range.push(i);
  }

  return range;
};

export const sliceArrayIntoChunks = (array, chunkSize) => {
  const result = [];
  const length = array.length;
  const normalizedChunkSize = Math.ceil(chunkSize);

  for (let i = 0; i < length; i += normalizedChunkSize) {
    result.push(array.slice(i, i + normalizedChunkSize));
  }

  return result;
};

export const getUniqById = items => {
  const result = [];

  items.forEach(item => {
    if (!result.map(resultItem => resultItem.id).includes(item.id)) {
      result.push(item);
    }
  });

  return result;
};

export const sortByTrueKey = sortKey => (x, y) => {
  if (x[sortKey] === y[sortKey]) return 0;
  else if (x[sortKey]) return -1;
  return 1;
};

export const sortCollection = (arr, param) =>
  arr && arr.sort
    ? arr.sort((a, b) => {
        if (!a || !b) {
          return 0;
        }
        if (a[param] > b[param]) {
          return 1;
        }
        if (a[param] < b[param]) {
          return -1;
        }
        return 0;
      })
    : arr;
export const cleanArray = array => array.filter(x => !!x);

export const compareByTitle = (a, b) => {
  const nameA = a.title.toUpperCase();
  const nameB = b.title.toUpperCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const compareByCount = (a, b) => -(parseInt(a.count, 10) - parseInt(b.count, 10));

export const objectToArray = object =>
  Object.entries(object)
    .map(([key, value]) => {
      if (typeof value === 'boolean') {
        return value ? key : null;
      }

      return value;
    })
    .filter(element => element !== null);

export const getSeoParamsTitles = (
  {
    make,
    model,
    generation,
    gearbox,
    engine,
    body,
    drive,
    isNew,
    location,
    rubric,
    part_type: partType,
    transport,
    year,
    country,
  },
  t,
) => ({
  ...(location && location.title ? { location: location.title } : {}),
  ...(country && country.is_country ? { country } : {}),
  ...(location && location.is_city ? { city: location } : {}),
  ...(make && make.title ? { make: make.title } : {}),
  ...(make && make[`${t('locale')}_title`] ? { makeTranslate: make[`${t('locale')}_title`] } : {}),
  ...(model && model.title ? { model: model.title } : {}),
  ...(model && model[`${t('locale')}_title`]
    ? { modelTranslate: model[`${t('locale')}_title`] }
    : {}),
  ...(generation && generation.title ? { generation: generation.title } : {}),
  ...(gearbox && gearbox.title ? { gearbox: t(gearbox.title) } : {}),
  ...(engine && engine.title ? { engine: t(engine.title) } : {}),
  ...(body && body.title ? { body: t(body.title) } : {}),
  ...(drive && drive.title ? { drive: t(drive.title) } : {}),
  ...(isNew ? { isNew } : {}),
  ...(rubric && rubric.title ? { rubric: rubric.title } : {}),
  ...(partType && partType.title ? { partType: partType.title } : {}),
  ...(partType && partType[`${t('locale')}_title`]
    ? { partTypeUk: partType[`${t('locale')}_title`] }
    : {}),
  ...(transport && transport.title ? { transport: t(transport.title) } : {}),
  ...(year ? { year } : {}),
});



// WEBPACK FOOTER //
// ./src/shared/helpers/arrays.js